export const TEACHER_GET_INFO_REQUEST = 'TEACHER_GET_INFO_REQUEST';
export const TEACHER_GET_INFO_SUCCESS = 'TEACHER_GET_INFO_SUCCESS';

export const OPEN_STUDENT_LIST = 'OPEN_STUDENT_LIST';
export const CLOSE_STUDENT_LIST = 'CLOSE_STUDENT_LIST';

export const GET_STUDENTS_LIST_REQUEST = 'GET_STUDENTS_LIST_REQUEST';
export const GET_STUDENTS_LIST_SUCCESS = 'GET_STUDENTS_LIST_SUCCESS';

export const STUDENTS_LIST_INVALIDATE = 'STUDENTS_LIST_INVALIDATE';

export const TEACHER_UPDATE_STUDENT_HOMEWORK_PERCENTAGE = 'TEACHER_UPDATE_STUDENT_HOMEWORK_PERCENTAGE';

export const TEACHER_CHANGE_STUDENT_COURSE = 'TEACHER_CHANGE_STUDENT_COURSE';

export const TEACHER_DELETE_STUDENT = 'TEACHER_DELETE_STUDENT';

export const TEACHER_UPDATE_STUDENT_NOTES = 'TEACHER_UPDATE_STUDENT_NOTES';

export const GET_STUDENT_AUTH_LINK_REQUEST = 'GET_STUDENT_AUTH_LINK_REQUEST';
export const GET_STUDENT_AUTH_LINK_SUCCESS = 'GET_STUDENT_AUTH_LINK_SUCCESS';

export const TEACHER_CHANGE_STUDENT_REQUEST = 'TEACHER_CHANGE_STUDENT_REQUEST';

export const TEACHER_UPDATE_BALANCE = 'TEACHER_UPDATE_BALANCE';
export const TEACHER_UPDATE_BALANCE_SUCCESS = 'TEACHER_UPDATE_BALANCE_SUCCESS';
export const TEACHER_RESET_CHARGED_STATE = 'TEACHER_RESET_CHARGED_STATE';
